<!--
<city @city="return city " :desc="dictDesc"></city>

-->
<template>
  <div class="box">
    <!--选择框-->
    <div class="input" :style="{width:width}" :class="{'active':active,'finish':finish}" @click="clickBox">
      <span class="please" v-if="!cityObg.pName && !cityObg.cName && !cityObg.dName">请选择</span>
      <span class="pName" v-show="showPName" v-if="cityObg.pName">{{cityObg.pName}}</span>
      <span class="CName" v-show="showCName" v-if="cityObg.cName">{{cityObg.cName}}</span>
      <span class="DName" v-show="showDName" v-if="cityObg.dName">{{cityObg.dName}}</span>
    </div>

    <!--省市区选择-->
    <div class="cityBox" v-if="active">
      <ul class="provinceBox">
        <li class="province" v-show="showPName" @click.stop="select('province')" :class="{'active':current === 'province'}">省份</li>
        <li class="city" v-show="showCName" @click.stop="select('city')" :class="{'active':current === 'city'}">城市</li>
        <li class="district" v-show="showDName" @click.stop="select('district')" :class="{'active':current === 'district'}">县区</li>
      </ul>

      <!--省-->
      <dl class="selectBox" v-if="current === 'province'">
        <dt class="Initials">A-G</dt>
        <dd class="nameBox">
          <a v-for="(item,index) in cityData['A-G']"
             class="provinceName"
             @click.stop="addCity(item)"
             :class="{'active':item.label === cityObg.pName }">
            {{item.label}}
          </a>
        </dd>

        <dt class="Initials">H-K</dt>
        <dd class="nameBox">
          <a v-for="(item,index) in cityData['H-K']"
             class="provinceName" @click.stop="addCity(item)"
             :class="{'active':item.label === cityObg.pName }">
            {{item.label}}
          </a>
        </dd>

        <dt class="Initials">L-S</dt>
        <dd class="nameBox">
          <a v-for="(item,index) in cityData['L-S']"
             class="provinceName"
             @click.stop="addCity(item)"
             :class="{'active':item.label === cityObg.pName }">
            {{item.label}}
          </a>
        </dd>

        <dt class="Initials">T-Z</dt>
        <dd class="nameBox">
          <a v-for="(item,index) in cityData['T-Z']"
             class="provinceName"
             @click.stop="addCity(item)"
             :class="{'active':item.label === cityObg.pName }">
            {{item.label}}
          </a>
        </dd>
      </dl>

      <!--市-->
      <ul class="selectCityBox" v-if="current === 'city'" @click="">
        <li class="cityName" v-for="(item,index) in city"
            :class="{'active':item.label === cityObg.cName }"
            @click.stop="addDistrict(item)">
          {{item.label}}
        </li>
      </ul>

      <!--区-->
      <ul class="selectDistrictBox" v-if="current === 'district'">
        <li class="districtName" v-for="(item,index) in district"
            @click.stop="postResult(item)"
            :class="{'active':item.label === cityObg.dName }">
          {{item.label}}
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
  export default {
    props:{
      'model':String,
      'desc':String,
      'level':Number,
      width:{
        type:String,
        default:'300px'
      }
    },
    name: "city",
    data(){
      return{
        active:false,
        finish:false,   //当城市选择完
        current: 'province',//当前状态 省|市|区
        city:[],
        district:[],
        showPName:true,
        showCName:true,
        showDName:true,
        cityObg:{
          pName:'',//省
          cName:'',//市
          dName:'',//区
          code:'' //编码
        }
      }
    },
    methods:{
      clickBox(){
        this.active = true;
        if(this.level==1||this.level==2){
          this.current='province';
        }
      },
      select(o){
        this.current = o
      },
      addCity(o){
        this.city = [];
        this.district = [];
        if(this.level!=1) {
          this.city = o.children;
        }
        this.current = 'city';
        this.cityObg.pName = o.label;
        this.cityObg.cName = '';
        this.cityObg.dName = '';
        this.cityObg.code = o.value;
        if (!this.city || this.city.length <= 0) {
          this.active = false;
        }
        this.$emit('city',this.cityObg)
      },
      addDistrict(o){
        this.district = [];
        if(this.level!=2) {
          this.district = o.children;
        }
        this.current = 'district';
        this.cityObg.cName = o.label;
        this.cityObg.dName = '';
        this.cityObg.code = o.value;
        if (!this.district || this.district.length <= 0) {
          this.active = false;
        }
        this.$emit('city',this.cityObg)

      },
      postResult(o){
        this.cityObg.dName = o.label;
        this.cityObg.code = o.value;
        this.active = false;
        this.$emit('city',this.cityObg)
      },
      showCityData(value) {
        if (value) {
          value = value.split("/");
          let data = {
            pName: value[0],
            cName: value[1],
            dName: value[2]
          }
          return data;
        }
      },
      setCity(province,city,dName){
        this.current = 'district';
        this.cityObg.pName =province;
        this.cityObg.cName = city;
        this.cityObg.dName = dName;
      }
    },
    computed:{
      cityData(){
        return this.$store.state.regionMap;
      }
    },
    watch:{
      desc(n,o){
        this.cityObg = this.showCityData(this.desc)
      }
    },
    mounted(){

      if(this.level==1){
        this.showCName=false;
        this.showDName =false;
      }else if(this.level==2){
        this.showDName =false;
      }
      if (this.desc) {
        this.cityObg = this.showCityData(this.desc);
        if (this.cityObg.dName) {
          this.current = 'district'
        } else if (this.cityObg.cName) {
          this.current = 'city';
        } else {
          this.current = 'province';
        }
        // 遍历获取回显城市数据
        for (let i in this.cityData) {
          this.cityData[i].map((index) => {
            if (index.label === this.cityObg.pName) {
              this.city = index.children
            }
          })
        }
        // 遍历获取回显地区数据
        this.city.map((index) => {
          if (index.label === this.cityObg.cName) {
            this.district = index.children
          }
        })
      }
      document.addEventListener('click', (e) => {
        if (!this.$el.contains(e.target)) {
          this.active = false;
        }
        // this.finish = true;
      });
    }
  }
</script>

<style lang="less" scoped>
  .box{
    line-height: 0;
    position: relative;
    .input{
      width: 300px;
      height: 32px;
      line-height: 32px;
      background: #FFFFFF;
      box-sizing: border-box;
      border: 1px solid rgba(0,0,0,0.15);
      border-radius: 4px;
      cursor: pointer;
      text-indent: 12px;
      overflow: hidden;
      span{
        color: rgba(0,0,0,0.65);
        font-size: 14px;
        &:after{
          content: '/';
          color: rgba(0,0,0,0.15);
        }
        &:last-child:after{
          display: none;
        }
      }
      &.active{
        border-color: #40A9FF;
      }
      &.finish{
        border-color: #67c23a;
      }
      .please{
        font-size: 14px;
        color: rgba(0,0,0,0.25);
      }
    }
    .cityBox{
      line-height: 0;
      position: absolute;
      left: 0;
      top: 34px;
      width: 500px;
      font-size: 14px;
      box-shadow: 0 2px 8px 0 rgba(0,0,0,0.15);
      border-radius: 4px;
      z-index: 100;
      background-color: #ffffff;
      .provinceBox{
        display: flex;
        cursor: pointer;
        li{
          list-style: none;
          flex:1;
          text-align: center;
          line-height: 37px;
          background-color: #EFF6FC;
          color: rgba(0,0,0,0.65);
          border-bottom: 1px solid rgba(0,0,0,0.09);
          &.active{
            color: #000000;
            font-weight: bold;
            background-color: #ffffff;
            border-bottom: none;
          }
        }
        .city{
          border-left: 1px solid rgba(0,0,0,0.09);
          border-right: 1px solid rgba(0,0,0,0.09);
        }
      }
      .selectBox{
        padding: 18px 32px 0 24px;
        .Initials{
          float: left;
          padding: 5px 8px 0 8px;
          line-height: 22px;
        }
        .nameBox{
          margin: 0 0 12px 42px;
          .provinceName{
            display: inline-block;
            height: 22px;
            padding: 0 8px 0 8px;
            margin: 0 10px 8px 0;
            line-height:22px;
            border-radius: 4px;
            cursor: pointer;
            &.active{
              color: #ffffff;
              background:rgba(0,120,215,1)
            }
            &:hover{
              color: #ffffff;
              background:rgba(0,120,215,1);
            }
          }
        }
      }
      .selectCityBox{
        padding: 16px 0 16px 24px;
        .cityName{
          display: inline-block;
          height: 22px;
          padding: 0 8px 0 8px;
          margin: 0 10px 8px 0;
          line-height:22px;
          border-radius: 4px;
          cursor: pointer;
          &.active{
            color: #ffffff;
            background:rgba(0,120,215,1)
          }
          &:hover{
            color: #ffffff;
            background:rgba(0,120,215,1);
          }
        }
      }
      .selectDistrictBox{
        padding: 16px 0 16px 24px;
        .districtName{
          display: inline-block;
          height: 22px;
          padding: 0 8px 0 8px;
          margin: 0 10px 8px 0;
          line-height:22px;
          border-radius: 4px;
          cursor: pointer;
          &.active{
            color: #ffffff;
            background:rgba(0,120,215,1)
          }
          &:hover{
            color: #ffffff;
            background:rgba(0,120,215,1);
          }
        }
      }
    }
  }
</style>
